const body = response => {
    const headers = response.headers;
    if (!headers.has("content-type") || headers.get("content-type").toLowerCase() === "application/json") {
        return response.json()
    } else {
        return Promise.resolve({});
    }
};

const http = (method, url, headers) => {
    return fetch(url, {
        method,
        headers: (headers || []).reduce((obj, item) => ({...obj, [item.key]: item.value}),{})
    })
    .then (r => {
        return body(r)
        .then(b => ({
            status: r.status,
            payload: b
        }));
    })
    .catch(err => {
        return Promise.reject(err);
    });
};

export { http };



// WEBPACK FOOTER //
// ./src/services/http.js